'use client';

import { useEffect } from 'react';
import type { Metadata } from 'next';
import HomepageInteractive from './components/HomepageInteractive';

// Note: Metadata export is not allowed in Client Components
// In production, move metadata to a parent Server Component or layout

export default function Homepage() {
  // Scroll reveal animation setup
  useEffect(() => {
    const reveals = document.querySelectorAll('.reveal');
    if (!reveals.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('active');
          }
        });
      },
      { threshold: 0.1 }
    );

    reveals.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <main className="min-h-screen">
      <HomepageInteractive />
    </main>
  );
}